import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";
import Table from "./table/Table";
import useFetch from "../../context/useFetch";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Province } from "../../Province";
// Others File

const Centers = () => {
  const [dataList, setDataList] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { province, city } = useParams();
  const getCenterList = useFetch({
    method: "post",
    url: `Center_Service/search_center`,
    trigger: true,
    noHeader: true,
    data: {
      province: province,
      city: city,
    },
    setter: setDataList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <div className="hp-section-one">
        <Navbar />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">مراکز پذیرش اسناد خسارت</p>
        <div className="bg-myorange-300 py-2 px-4 mt-8 rounded-lg flex items-center">
          <div className="border-l-2 border-white pl-8">
            <span className="text-mygray-700">
              استان‌: {Province.filter((it) => it.value == province)[0].name}
            </span>
          </div>
          <div className="mr-8">
            <span className="text-mygray-700">شهر: {city}</span>
          </div>
        </div>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
          <Table dataList={dataList} />
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Centers;
